import { render, staticRenderFns } from "./SendAnimaCompare.vue?vue&type=template&id=84a97ec8&scoped=true&"
import script from "./SendAnimaCompare.vue?vue&type=script&lang=ts&"
export * from "./SendAnimaCompare.vue?vue&type=script&lang=ts&"
import style0 from "./SendAnimaCompare.vue?vue&type=style&index=0&id=84a97ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a97ec8",
  null
  
)

export default component.exports